import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <span className="text-9xl">🔍</span>
        <h1 className="text-6xl font-display font-bold text-gray-900 mt-8 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page introuvable</h2>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          La page que vous cherchez n'existe pas ou a été déplacée. 
          Pas de panique, vous pouvez retourner à l'accueil.
        </p>
        <Link to="/" className="btn-primary">
          Retour à l'accueil
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;